import { Box, CircularProgress, IconButton, Paper, Typography, Button } from "@mui/material"
import { useCallback, useEffect, useState } from "react";
import { getGoogleCalendarList } from "../../services/google-calendar";
import { CheckCircle, ContentCopy, Settings } from "@mui/icons-material";
import { enqueueSnackbar } from "notistack";

const GoogleCalendarConnect = ({
  user_id,
  user_email
}) => {

  const [is_loading, set_is_loading] = useState(true);
  const [is_calendar_found, set_is_calendar_found] = useState(false);

  const getCalendarData = useCallback(async () => {

    set_is_loading(true);

    if (user_id) {
      const { data } = await getGoogleCalendarList({
        user_id: user_id
      });

      if (data && data.is_calendar_found) {

        console.log(data);
        set_is_calendar_found(true);
      }

      set_is_loading(false);
    }

  }, [user_id])

  useEffect(() => {
    getCalendarData();
  }, [getCalendarData])

  const handleCopyEmail = async () => {
    await navigator.clipboard.writeText("spiritual-tara-calendar@spiritual-tara.iam.gserviceaccount.com");
    enqueueSnackbar('Copied', {
      variant: "info"
    })
  }

  return (
    <Paper
      elevation={4}
      sx={{
        padding: '20px'
      }}
    >
      <Typography
        variant="h6"
        borderBottom="1px solid #ccc"
        paddingBottom="10px"
        marginBottom="20px"
      >
        Google Calendar Connection Status
      </Typography>

      {
        is_loading ?
          <Box
            display="flex"
            justifyContent="center"
          >
            <CircularProgress />
          </Box>
          :
          <>
            {
              is_calendar_found ?
                <Box
                  display="flex"
                  alignItems="center"
                  gap="10px"
                >
                  <Typography>
                    Connected
                  </Typography>

                  <CheckCircle
                    color="success"
                  />
                </Box> :
                <Box
                  display="flex"
                  flexDirection="column"
                  gap="20px"
                >
                  <Typography>
                    Calendar not connected
                  </Typography>

                  <Typography>
                    Please follow below steps to connect your calendar :
                  </Typography>

                  <ol
                    style={{
                      margin: 0
                    }}
                  >
                    <li>
                      <Typography>
                        Copy this email address
                      </Typography>
                      <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                        gap="10px"
                      >
                        <Typography>
                          spiritual-tara-calendar@spiritual-tara.iam.gserviceaccount.com
                        </Typography>

                        <IconButton
                          size="small"
                          onClick={handleCopyEmail}
                        >
                          <ContentCopy
                            fontSize="10px"
                          />
                        </IconButton>
                      </Box>
                    </li>

                    <li>
                      <Typography>
                        Open <a href="https://calendar.google.com/" target="_blank" rel="noreferrer noopener"> Google Calendar </a>
                      </Typography>
                    </li>

                    <li>
                      <Typography>
                        It must be logged in with your email account <b>"{user_email}"</b>
                      </Typography>
                    </li>

                    <li>
                      <Typography
                        display="flex"
                        alignItems="center"
                      >
                        Click on settings (<Settings fontSize="12px" />) {"icon > Settings"}
                      </Typography>
                    </li>

                    <li>
                      <Typography>
                        On left sidebar go to "Settings for my calendars" section and click on your name
                      </Typography>
                    </li>

                    <li>
                      <Typography>
                        Then click on "Shared with" on left sidebar
                      </Typography>
                    </li>

                    <li>
                      <Typography>
                        On Right Side, click on "Add people and groups" button
                      </Typography>
                    </li>

                    <li>
                      <Typography>
                        Paste "spiritual-tara-calendar@spiritual-tara.iam.gserviceaccount.com" this email
                      </Typography>
                    </li>

                    <li>
                      <Typography>
                        From "Permissions" dropdown, select "Make changes to events"
                      </Typography>
                    </li>

                    <li>
                      <Typography>
                        Click on "Send"
                      </Typography>
                    </li>

                    <li>
                      <Typography>
                        Click on "Refresh" button below to check if calendar is connected succcessfully !
                      </Typography>
                    </li>
                  </ol>

                  <Box
                    display="flex"
                    justifyContent="flex-end"
                  >
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={getCalendarData}
                    >
                      Refresh
                    </Button>
                  </Box>
                </Box>
            }
          </>
      }
    </Paper>
  )
}

export default GoogleCalendarConnect;